import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../Context/authContext';
import Forbidden from './Forbidden';
import RoutesPath from '../Utils/RoutesPath';

const ProtectedRoute = ({ requiredParameter, requiredAction }) => {
  const { user } = useContext(AuthContext);

  if (!user) {
    // User is not authenticated, redirect to login page
    return <Navigate to={RoutesPath.login} replace />;
  }

  if (requiredParameter && requiredAction) {
    const hasPermission = user?.setPrivileges?.some(
      privilege => privilege.parameter === requiredParameter && privilege[requiredAction]
    );

    if (!hasPermission) {
      // User doesn't have the required permission, show Forbidden component
      return <Forbidden />;
    }
  }

  // User is authenticated and authorized, render the child routes
  return <Outlet />;
};

export default ProtectedRoute;